<script>
import Report from '../../../classes-internal/reports/Report'
import DateHelper from '../../../classes-shared/utils/DateHelper'
import BookingEntryFilterable from '../../../classes-shared/bookings/BookingEntryFilterable'
import ExtraRides from '../../../classes-internal/extraRides/ExtraRides'
import BookingAggregatedService from '../../../classes-shared/bookings/BookingAggregatedService'

export default {
  name: 'ReportsMixin',

  props: {
    // selected date to generate the report
    date: {
      type: String,
      required: true,
    },

    report: {
      type: Report,
      required: true,
    },
  },

  data() {
    return {
      bookingAggregated: new BookingAggregatedService(),
      bookingEntryFilterable: new BookingEntryFilterable({}),
      extraRides: new ExtraRides(),
    }
  },

  computed: {
    fromDateIsoString() {
      let fromDate = new Date(this.date)
      fromDate.setHours(0, 0, 0, 0)
      return DateHelper.shiftLocalToUtcIsoString(fromDate)
    },

    toDateIsoString() {
      let endDate = new Date(this.date)
      endDate.setHours(23, 59, 59, 999)
      return DateHelper.shiftLocalToUtcIsoString(endDate)
    },
  },

  methods: {
    // load single booking entries
    async loadBookingEntriesFilterable(productId = null) {
      await this.bookingEntryFilterable.loadFilteredBookingEntries(
        this.fromDateIsoString,
        this.toDateIsoString,
        productId
      )
    },

    async loadGroups() {
      let startDate = new Date(this.date)
      let endDate = new Date(this.date)
      startDate.setHours(0, 0, 0, 0)
      endDate.setDate(startDate.getDate() + 1)
      await this.extraRides.getExtraRideByDate(
        DateHelper.shiftLocalToUtcIsoString(startDate),
        DateHelper.shiftLocalToUtcIsoString(endDate)
      )
      return Promise.resolve(true)
    },

    async loadAggregatedBookings() {
      await this.bookingAggregated.fetchAggregatedBookings(
        this.fromDateIsoString,
        this.toDateIsoString
      )
    },
  },
}
</script>
